// extracted by mini-css-extract-plugin
export default {"page":"BaseLandingV2_page__a+m0-"};